var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1163",
    "data-name": "Group 1163",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ffc27a;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6096",
    "data-name": "Group 6096"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    className: "cls-1",
    width: 18,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Back_Button",
    "data-name": "Back Button",
    transform: "translate(12.764 4.907) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_d_Down-arrow-16",
    "data-name": "icons/d/Down-arrow-16",
    transform: "translate(4.185) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-2",
    d: "M0,0,3.829,4.185,7.659,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownSort);
export default __webpack_public_path__ + "static/media/DropDownSort.5951fbd69f6afd792cc7eacb56f2c329.svg";
export { ForwardRef as ReactComponent };